import { render, staticRenderFns } from "./SwitchAccountView.vue?vue&type=template&id=e5352b58&scoped=true&"
import script from "./SwitchAccountView.vue?vue&type=script&lang=js&"
export * from "./SwitchAccountView.vue?vue&type=script&lang=js&"
import style0 from "./SwitchAccountView.vue?vue&type=style&index=0&id=e5352b58&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5352b58",
  null
  
)

export default component.exports